import { render, staticRenderFns } from "./textBook.vue?vue&type=template&id=22822f9a&scoped=true&"
import script from "./textBook.vue?vue&type=script&lang=js&"
export * from "./textBook.vue?vue&type=script&lang=js&"
import style0 from "./textBook.vue?vue&type=style&index=0&id=22822f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22822f9a",
  null
  
)

export default component.exports